import { Button } from 'components/common/Button'
import routes from 'constants/routes'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'

export const NoSavedReleases = () => {
  const { t } = useTranslation('release_calendar')

  const btnProps = {
    pill: true,
    style: 'solid-primary',
    type: 'link',
    href: routes.releaseCalendar.base,
  } as const

  return (
    <div className='flex h-full w-full flex-col items-center justify-center space-y-6 rounded-lg bg-purple-50/50 px-6 py-8 lg:p-8'>
      <div className='space-y-1 text-center'>
        <h3 className='font-body text-lg font-medium tracking-normal lg:text-2xl'>
          {t('no_saved_releases_yet')}
        </h3>

        <h4 className='font-body text-xs font-normal tracking-normal text-cool-700 lg:text-sm'>
          {t('click_on_the_bell_icon')}
        </h4>
      </div>

      <div>
        <div className='lg:hidden'>
          <Button {...btnProps} size='md'>
            {t('view_all_releases')}
          </Button>
        </div>

        <div className='hidden lg:block'>
          <Button {...btnProps} size='lg'>
            {t('view_all_releases')}
          </Button>
        </div>
      </div>

      <Image
        src='/files/release-calendar/release-saved.png'
        alt='Saved release'
        width={200}
        height={240}
      />
    </div>
  )
}
